import { createSelector } from 'reselect';

const convertCollectionToSelector = items =>
  items.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

export const baseDirections = state => state.collections.directions;
export const baseEventTypes = state => state.collections.eventTypes;
export const baseGames = state => state.collections.game;
export const basePlatforms = state => state.collections.platform;
export const baseVersions = state => state.collections.versions;
export const baseResponsible = state => state.collections.responsible;
export const baseChannels = state => state.collections.channels;
export const baseClassTags = state => state.collections.classTags;
export const baseTechTags = state => state.collections.techTags;
export const baseTypeTags = state => state.collections.typeTags;
export const baseExtraFieldsList = state => state.collections.extraFieldsList;

export const directions = createSelector(
  baseDirections,
  convertCollectionToSelector,
);

export const eventTypes = createSelector(
  baseEventTypes,
  convertCollectionToSelector,
);

export const game = createSelector(baseGames, convertCollectionToSelector);

export const responsible = createSelector(
  baseResponsible,
  convertCollectionToSelector,
);

export const platform = createSelector(
  basePlatforms,
  convertCollectionToSelector,
);

export const versions = createSelector(baseVersions, versions =>
  versions.map(version => version.id),
);

export const channels = createSelector(
  baseChannels,
  convertCollectionToSelector,
);

export const classTags = createSelector(
  baseClassTags,
  convertCollectionToSelector,
);

export const techTags = createSelector(
  baseTechTags,
  convertCollectionToSelector,
);

export const typeTags = createSelector(
  baseTypeTags,
  convertCollectionToSelector,
);
